import React from "react";
import { Typography } from "@material-ui/core";
const IllustrationIcon = ({
  icon,
  color,
  description,
  guidance,
}) => {
  return (
    <div className="center-vertical">
      <div className="d-flex justify-content-center">
        <div className="column">
          <div className="col-sm-12 col-md-12 col-lg-12 mb-3">
            <div className="row justify-content-center">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <div className="text-center">
                  <React.Fragment>
                    <Typography component="span" align="center">
                      <i className={`${icon} kt-font-${color}`}
                        style={{ fontSize: 100 }} />
                    </Typography>
                  </React.Fragment>
                </div>
              </div>
            </div>
          </div>
          {description ? (
            <div className="col-sm-12 col-md-12 col-lg-12 mb-3">
              <React.Fragment>
                <Typography component="span" align="center">
                  <div className="illustration-description text-center">{description}</div>
                </Typography>
              </React.Fragment>
            </div>
          ) : null
          }
          {guidance ? (
            <div className="col-sm-12 col-md-12 col-lg-12 mb-3">
              <React.Fragment>
                <Typography component="span" align="center">
                  <div className="illustration-guidance text-center">{guidance}</div>
                </Typography>
              </React.Fragment>
            </div>
          ) : null
          }
        </div>
      </div>
    </div>
  );
};

export default IllustrationIcon;
